<div *ngIf="question != null" [ngSwitch]="question.inputType">
  <div class="options" *ngSwitchCase="listQuestionTypes.includes(question.inputType) ? question.inputType : ''">
    <kp-word-list
      [min]="question?.settings?.countMin"
      [max]="question?.settings?.countMax"
      [displayOptions]="options"
      [questionType]="question.inputType"
      (answerSelected)="answer.emit($event)"></kp-word-list>
  </div>
  <div class="checkbox-options" *ngSwitchCase="questionType.checkbox">
    <kp-checkbox-list
      [min]="question?.settings?.countMin"
      [max]="question?.settings?.countMax"
      [displayOptions]="options"
      (checkboxesChecked)="answer.emit($event)"></kp-checkbox-list>
  </div>
  <div class="text-field" *ngSwitchCase="textQuestionTypes.includes(question.inputType) ? question.inputType : ''">
    <kp-text-field
      [maxCharacters]="maxCharacters"
      [placeholderText]="placeholderText"
      [textValue]="answerValue"
      (textAreaAnswer)="answer.emit($event)"
      [isShortText]="question.inputType === questionType.short_text"
      data-e2e="answerTextField"></kp-text-field>
  </div>
  <div class="scale-question" *ngSwitchCase="questionType.slider">
    <kp-slider [question]="question" (sliderAnswer)="answer.emit($event)"></kp-slider>
  </div>
  <div class="scale-question" *ngSwitchCase="questionType.likert">
    <kp-diamond-likert [question]="question" (likertAnswer)="answer.emit($event)"></kp-diamond-likert>
  </div>
  <div class="radio-button" *ngSwitchCase="questionType.radio_button">
    <kp-radio-button [question]="question" (radioAnswer)="answer.emit($event)"></kp-radio-button>
  </div>
</div>
